import { Admin } from '@/types/user';
import { QueryKey } from '@/configs/queryKeys';
import EntityApi from './EntityApi';

class AdminApi extends EntityApi<Admin> {
	constructor() {
		super(QueryKey.admins);
	}
}

export default new AdminApi();
